function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "call") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M329.43,457.135c-5.265,3.041-31.508,4.777-69.43-16.509-58.854-33.035-104.079-96.9-131.654-144.664-27.553-47.723-60.124-118.591-58.821-185.195C70,86.635,74.868,69.126,80.1,57.937l-9.523,5.5c-6.254,3.61-20.238,25.578-21.055,67.332-1.3,66.6,31.268,137.472,58.821,185.2,27.575,47.761,72.8,111.629,131.654,144.664,37.922,21.286,64.165,19.55,69.43,16.509l48.505-28a18.7,18.7,0,0,0,9.031-13.667Z",
    style: {
      fill: "#d4e1f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.082,493c7.682,0,14.071-1.269,18.348-3.738l48.505-28a32.661,32.661,0,0,0,11.937-44.564l-31.187-54.015a32.842,32.842,0,0,0-19.849-15.243,32.172,32.172,0,0,0-24.867,3.032L273.41,366.376c-.055.031-.109.064-.164.1-.1.062-10.76,6.183-28.286,1.744-19.181-4.861-49.271-23.172-83.7-82.8-32.276-55.9-33.774-89.991-29.347-108.745,4.555-19.3,15.923-26.271,16.546-26.639l.032-.019L176.05,134.1a32.187,32.187,0,0,0,15.064-20,32.8,32.8,0,0,0-3.266-24.8L156.662,35.275a32.84,32.84,0,0,0-44.576-11.968l-48.506,28C57.021,55.1,50.371,64.42,45.336,76.888c-4.2,10.4-9.311,28.142-9.809,53.6C34.162,200.319,67.779,273.7,96.221,322.962c28.452,49.279,75.3,115.283,136.926,149.872,22.5,12.626,40.538,17.343,51.713,19.077A86.817,86.817,0,0,0,298.082,493ZM108.346,315.962C80.793,268.239,48.222,197.371,49.525,130.767c.817-41.754,14.8-63.722,21.055-67.332l48.506-28a18.182,18.182,0,0,1,9.124-2.437,19.167,19.167,0,0,1,4.986.666,18.507,18.507,0,0,1,11.341,8.615l31.186,54.016a18.885,18.885,0,0,1,1.842,14.283,18.294,18.294,0,0,1-8.515,11.4l-27.56,15.912c-1.393.805-16.162,9.805-22.523,32.9-8.583,31.166,1.566,72.086,30.167,121.625,29.6,51.272,60.686,81.342,92.388,89.376,22.5,5.7,37.175-2.286,38.9-3.3l27.546-15.9a18.286,18.286,0,0,1,14.132-1.665,18.922,18.922,0,0,1,11.459,8.751l31.187,54.015a18.872,18.872,0,0,1-6.812,25.44l-48.5,28c-5.265,3.041-31.508,4.777-69.43-16.509C181.146,427.591,135.921,363.723,108.346,315.962Z",
    style: {
      fill: "#2f55d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.722,337.391a35.017,35.017,0,0,1,30.192,52.293,7,7,0,1,0,12.182,6.9,49.016,49.016,0,0,0-42.257-73.191h-.06a7,7,0,0,0-.057,14Z",
    style: {
      fill: "#2eca8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.547,424.731a7,7,0,0,0,9.888-.462,77.057,77.057,0,0,0-73.4-127.14,7,7,0,1,0,2.987,13.678,63.057,63.057,0,0,1,60.065,104.036A7,7,0,0,0,418.547,424.731Z",
    style: {
      fill: "#2eca8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.14,285.542A91.065,91.065,0,0,1,433.025,439.5a7,7,0,1,0,9.455,10.324,105.065,105.065,0,0,0-102.555-177.63,7,7,0,1,0,4.215,13.351Z",
    style: {
      fill: "#2eca8b"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.21660a6e213c618232c9c638e08759bf.svg";
export { ForwardRef as ReactComponent };